import axios from 'axios';

const api = axios.create({ baseURL: 'https://backend.hasthiya.com/api' });

// Attach token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('ehrm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirect to login on 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ehrm_user');
      localStorage.removeItem('ehrm_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
